var defaultSDKSettingsResponse = {
    appVersion: 'unknown',
    nativeSocialTypesEnabled: []
};

var defaultTransactionDataResponse = {
    transactionId: undefined,
    mfaOperationCode: undefined,
    currency: 'USD',
    amount: '0',
    statement: {
        date: '19 March 2025',
        time: '19:20'
    }
};

export { defaultSDKSettingsResponse, defaultTransactionDataResponse };
